export default {
    baseStyle: {
        position: { base: 'absolute', lg: 'static' },
        top: '0',
        bottom: 'auto',
        width: '100%',
        minH: { base: '56px', lg: '48px' },
        paddingLeft: { base: 4, lg: 3 },
        paddingRight: { base: 4, lg: 3 },
        fontSize: { base: '14px' },
        lineHeight: { base: '18px' },
        letterSpacing: { base: '0px' },
        right: 0,
        left: 0,
        zIndex: 1410
    }
}
